import { useTranslation } from "react-i18next";
import {
  BadgeCheck,
  Clock,
  FileText,
  Languages,
  MapPin,
  MapPinned,
  ReceiptText,
  ShieldCheck,
} from "lucide-react";
import { AnimatedSection } from "@/components/home/AnimatedSection";

const valueItems = [
  { key: "locations", icon: MapPin },
  { key: "availability", icon: Clock },
  { key: "language", icon: Languages },
  { key: "doctors", icon: BadgeCheck },
  { key: "pricing", icon: ReceiptText },
  { key: "tracking", icon: MapPinned },
  { key: "documents", icon: FileText },
  { key: "insurance", icon: ShieldCheck },
] as const;

export const DoctorVisitsValue = () => {
  const { t } = useTranslation("doctorVisits");

  return (
    <section id="visit-benefits" tabIndex={-1} className="bg-muted px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
      <AnimatedSection className="mx-auto max-w-[1168px]">
        <div className="grid gap-12 lg:grid-cols-[0.78fr_1.22fr] lg:gap-20">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.16em] text-primary">
              {t("value.eyebrow")}
            </p>
            <h2 className="mt-4 max-w-lg text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
              {t("value.title")}
            </h2>
          </div>

          <div className="grid gap-x-10 gap-y-9 sm:grid-cols-2">
            {valueItems.map(({ key, icon: Icon }) => (
              <div key={key} className="border-l-2 border-primary/25 pl-5">
                <Icon className="h-5 w-5 text-primary" aria-hidden="true" />
                <h3 className="mt-4 text-lg font-semibold text-foreground">
                  {t(`value.items.${key}.title`)}
                </h3>
                <p className="mt-2 leading-7 text-muted-foreground">
                  {t(`value.items.${key}.description`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </AnimatedSection>
    </section>
  );
};
